import DescriptionsIcon from './descriptions-icon';

export default DescriptionsIcon;
